module.exports = __webpack_public_path__ + "img/activity_christmas2.4c4733a2.jpg";